import { useState } from "react";
import { Link, useHistory } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            password,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(data.message || "Մուտքը չհաջողվեց");
        return;
      }

      localStorage.setItem("token", data.token);

      alert("Մուտքը հաջողությամբ կատարվեց");

      history.push("/");
    } catch (error) {
      console.error(error);
      alert("Սերվերի հետ կապի սխալ");
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Մուտք</h1>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Էլ․ փոստ"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Գաղտնաբառ"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit">Մուտք գործել</button>
        </form>

        <p>
          Դեռ գրանցված չե՞ս։{" "}
          <Link to="/register">Գրանցվել</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;